import { calculateNewNodePosition } from './flowPositioning';
import { normalizeAutomationFlow } from './triggerFilterContract';

// Inicializa o flow no store (quando carrega uma automação existente ou cria uma nova)
export const initializeFlow = (store, flowData = null) => {
  if (flowData && flowData.nodes && (flowData.connections || flowData.edges)) {
    // Carregar flow existente
    store.dispatch(
      'automationFlow/initFlow',
      normalizeAutomationFlow(flowData)
    );
  } else {
    // Iniciar um novo flow com um nó trigger padrão
    store.dispatch('automationFlow/initFlow');
  }
};

// Exporta o flow atual para salvar.
//
// IMPORTANTE: deep clone via JSON.parse(JSON.stringify(...)) garante que o
// payload enviado ao backend não contenha Vue/Vuex reactive proxies. Sem o
// clone, em certas configurações de build o axios pode serializar proxies
// de forma incompleta, gerando payload com nodes/connections vazios — causa
// raiz reportada em produção ("salvei e voltou em branco"). O clone é
// idempotente e barato para o volume típico de um flow (< 100 nodes).
export const exportFlow = store => {
  const flow = store.state.automationFlow.flow;
  return normalizeAutomationFlow(
    JSON.parse(
      JSON.stringify({
        nodes: flow.nodes || [],
        connections: flow.connections || [],
      })
    )
  );
};

// Adiciona um novo nó ao flow
export const addNode = async (
  store,
  { type, parentNodeId = null, data = {} }
) => {
  const nodes = store.state.automationFlow.flow.nodes;
  const position = calculateNewNodePosition(nodes, parentNodeId);

  // Configurar dados específicos para cada tipo de nó
  let nodeData = { ...data };

  switch (type) {
    case 'trigger':
      nodeData = {
        label: data.label || 'Trigger',
        type: 'message_received',
        ...data,
      };
      break;
    case 'condition':
      nodeData = {
        label: data.label || 'Condition',
        field: '',
        operator: 'equals',
        value: '',
        ...data,
      };
      break;
    case 'action':
      nodeData = {
        label: data.label || 'Action',
        type: 'send_message',
        ...data,
      };
      break;
    default:
      nodeData = { ...data };
  }

  // Criar o nó (await para obter o ID retornado pela action)
  const nodeId = await store.dispatch('automationFlow/createNode', {
    type,
    position,
    data: nodeData,
  });

  // Se houver um nó pai, criar conexão automática
  if (parentNodeId) {
    store.dispatch('automationFlow/connectNodes', {
      sourceId: parentNodeId,
      targetId: nodeId,
    });
  }

  return nodeId;
};

// NOTE: dead `validateFlow` helper removed (P3-4). The frontend now uses
// `pipelineAutomationsAPI.validateFlow()` which delegates to the backend
// FlowValidator (the authoritative validation; covers ~10x more cases).
